// extracted by mini-css-extract-plugin
module.exports = {"tarjeta":"ContactosModal_tarjeta__Rwo84","img":"ContactosModal_img__3tJ95"};